export function isReadonlyMode() {
    return window.IS_READONLY === true;
}

export function isProductSupportMode() {
    return window.PRODUCT_SUPPORT_MODE === true;
}

export function isProductSupportReadonlyMode() {
    return window.IS_READONLY === true && window.PRODUCT_SUPPORT_MODE === true;
}

export function isAccountSharingReadonlyMode() {
    return window.IS_READONLY === true && window.PRODUCT_SUPPORT_MODE !== true;
}

export function isRaceManagementMode() {
    return window.IS_RACE_MANAGEMENT === true;
}

export const FeatureAction = {
    View: 'View',
    Edit: 'Edit',
    Delete: 'Delete'
};

const FeatureActionBitLocation = {
    View: 2,
    Edit: 1,
    Delete: 0
};

/**
 * Check if user has View / Edit / Delete access to feature
 * @param {*} feature key of FEATURES_ACCESS
 * @param {FeatureAction} action
 * @returns
 */
export function hasAccess(feature, action) {
    const featuresAccess = window.FEATURES_ACCESS;
    if (!featuresAccess) {
        return true;
    }

    const featureAccess = featuresAccess[feature];

    if (!featureAccess) {
        // Not available
        return false;
    }

    if (!action) {
        return true;
    }

    try {
        return checkBit(featureAccess, FeatureActionBitLocation[action]);
    } catch (error) {
        console.error(error);
        return false;
    }
}

/**
 * Util function to check if GCW is launched by Harmony Connect App, which would inject the predefined object into window on launching the webview
 * @returns {boolean}
 */
export function isLaunchByHarmonyConnectApp() {
    // Currently it's expected to be an empty object, and might be extended in the future
    return !!window.LAUNCH_BY_HARMONY_CONNECT_APP;
}

export function blockInReadOnly() {
    if (isReadonlyMode()) {
        return () => Window.App.displayPageNotFoundPage();
    }
}

export function blockInAccountSharingReadonly() {
    if (isAccountSharingReadonlyMode()) {
        return () => Window.App.displayPageNotFoundPage();
    }
}

export function blockInProductSupportReadonly() {
    if (isProductSupportReadonlyMode()) {
        return () => Window.App.displayPageNotFoundPage();
    }
}

// This is the Middleware for redux store
// Actions on this list will be ignored
// - No group in Account Sharing / read-only mode
export const accountSharingFilterMiddleware = (storeAPI) => (next) => (action) => {
    switch (action.type) {
        case 'REQUEST_CALENDAR_WEEK':
        case 'REQUEST_CALENDAR_MONTH':
            if (action.groupId) {
                return;
            }
        default:
            return next(action);
    }
};

/**
 * Check if decimal number at selected position is on or off
 * @param {number} decimalNumber decimal number
 * @param {number} position
 * @returns bool
 */
function checkBit(decimalNumber, position) {
    if (typeof decimalNumber === 'undefined' || typeof position === 'undefined') {
        throw Error('number and position are required');
    }
    const mask = 1 << position;
    return (decimalNumber & mask) !== 0;
}
